<template>
  <iSpace
    :height="myHeight"
    :width="myWidth"
    :style-overrides="{
      backgroundColor: getOptionValue(BackgroundColor),
      hoverBackgroundColor: getOptionValue(BackgroundColor, BaseOption.$states.HOVER),
    }"
  />
</template>

<script>
import { StandardSpacerElementMixin } from
  "%/dynamic-components/render-engine/components/production/elements/spacer-element/standard-spacer-element-mixin";
import BackgroundColor from "%/dynamic-components/render-engine/options/background-options/background-color";
import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import BackgroundRepeat from "%/dynamic-components/render-engine/options/background-options/background-repeat";
import BackgroundPosition from "%/dynamic-components/render-engine/options/background-options/background-position";
import BackgroundSize from "%/dynamic-components/render-engine/options/background-options/background-size";
import AnimationEffectsOptions from "%/dynamic-components/render-engine/bundles/animation-effects-options";

export default {
  name: "SpacerElement",
  mixins: [StandardSpacerElementMixin],
  options: [
    BackgroundColor,
  ],
  optionBundles: [
    AnimationEffectsOptions,
  ],
  data() {
    return {
      BaseOption,
      BackgroundRepeat,
      BackgroundPosition,
      BackgroundColor,
      BackgroundSize,
    };
  },
};
</script>

<style scoped lang="scss">
</style>
